import React, { useState, useEffect } from 'react';
import ScoresTab from './ScoresTab';
import ImproveTab from './ImproveTab';
import ImpactTab from './ImpactTab';

/**
 * forcedTab — when set by mobile parent, overrides local tab state.
 * When null/undefined, panel manages its own tab state (desktop).
 */
const IntelligencePanel = ({ result, resultIdx, fixStates, onAcceptFix, onManualRewrite, forcedTab }) => {
  const [localTab, setLocalTab] = useState('impact');

  // Sync local tab with forced tab when it changes
  useEffect(() => {
    if (forcedTab) setLocalTab(forcedTab);
  }, [forcedTab]);

  const activeTab = forcedTab || localTab;

  return (
    <div className="intel-panel">
      {/* Tab bar — hidden on mobile when forcedTab is provided (mobile uses outer tabs) */}
      {!forcedTab && (
        <div className="intel-tabs">
          <button
            className={`intel-tab ${activeTab === 'impact' ? 'intel-tab--active' : ''}`}
            onClick={() => setLocalTab('impact')}
          >
            Impact
          </button>
          <button
            className={`intel-tab ${activeTab === 'scores' ? 'intel-tab--active' : ''}`}
            onClick={() => setLocalTab('scores')}
          >
            Scores
          </button>
        </div>
      )}

      <div className="intel-body">
        {result ? (
          result.failed ? (
            <div style={{ padding: 24, color: 'var(--text-tertiary)', fontSize: 13, textAlign: 'center' }}>
              No data — this document failed to generate.
            </div>
          ) : activeTab === 'scores' ? (
            <ScoresTab key={result.docType} result={result} />
          ) : activeTab === 'improve' ? (
            <ImproveTab
              key={result.docType}
              result={result}
              resultIdx={resultIdx}
              fixStates={fixStates}
              onAcceptFix={onAcceptFix}
              onManualRewrite={onManualRewrite}
            />
          ) : (
            <ImpactTab key={result.docType} result={result} onTabChange={setLocalTab} />
          )
        ) : (
          <div style={{ padding: 24, color: 'var(--text-tertiary)', fontSize: 13, textAlign: 'center' }}>
            Select a document to view scores.
          </div>
        )}
      </div>
    </div>
  );
};

export default IntelligencePanel;
